// extracted by mini-css-extract-plugin
export default {"category":"_3VymKcNg8F3y3CsC8Eslji","block":"_2AUL2mkjo-AmD128ZuvA5C"};